import { Node } from 'slate'

export const serializePlain = (nodes) => {
  return nodes.map((n) => Node.string(n)).join('\n')
}
